import { Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { StyledAttachments } from "./styles";
import AttachmentsTable from "./Table";
import CreateAttachmentModal from "./CreateAttachmentModal";
import { useState } from "react";
import { useTaskAttachments } from "../../../../hooks/useTaskAttachments";

const Attachments = ({ task, tenant_id }) => {
  const [showModal, setShowModal] = useState(false);
  const { attachments, loading } = useTaskAttachments(task, tenant_id);
  return (
    <StyledAttachments>
      <div className="flex justify-space-between">
        <h3>Attachments</h3>
        <Button
          type="text"
          className="add-btn"
          icon={<PlusOutlined />}
          onClick={() => setShowModal(true)}
        />
      </div>
      <AttachmentsTable
        attachments={attachments}
        loading={loading}
        task={task}
      />
      {showModal && (
        <CreateAttachmentModal
          onCancel={() => setShowModal(false)}
          selectedTask={task}
        />
      )}
    </StyledAttachments>
  );
};

export default Attachments;
